import {
  ACTIVITIES_RESPONSE_VARIANT_IMAGE,
  ACTIVITIES_RESPONSE_VARIANT_TEXT,
  ACTIVITIES_RESPONSE_VARIANT_TEXT_IMAGE,
  InquisitiveActivitiesResponseVariant,
} from 'global/constants';
import {
  DragItem,
  DropItem,
} from '../../shared/interactive-drag-drop/interactive-drag-drop.constants';
import { translateElement } from '../../shared/interactive-drag-drop/interactive-drag-drop.utils';

export function checkAnswer(dropItem: DropItem, dragItem: DragItem) {
  for (let j = 0; j < dropItem.zones.length; j++) {
    const zone = dropItem.zones[j];
    if (dragItem.id === zone.dragItemId) {
      zone.isCorrect = dragItem.value === dropItem.id;
    }
  }
  return dropItem;
}

export function checkAnswers(
  dropItems: DropItem[],
  dragItems: DragItem[]
): DropItem[] {
  for (let i = 0; i < dropItems.length; i++) {
    const dropItem = dropItems[i];
    const id = dropItem.id;
    for (let j = 0; j < dropItem.zones.length; j++) {
      const zone = dropItem.zones[j];
      if (zone.dragItemId) {
        const dragItem = dragItems.find(di => di.id === zone.dragItemId);
        zone.isCorrect = dragItem?.value === id;
      }
    }
  }
  return dropItems;
}

export function isEverythingCorrect(
  dropItems: DropItem[],
  dragItems: DragItem[]
) {
  const markedItems = checkAnswers(dropItems, dragItems);
  let totalItems = dragItems.length;
  let totalCorrect = 0;
  for (let i = 0; i < markedItems.length; i++) {
    const dropItem = markedItems[i];
    totalCorrect += dropItem.zones.filter(z => z.isCorrect).length;
  }
  return totalCorrect === totalItems;
}

export function getResults(dropItems: DropItem[], dragItems: DragItem[]) {
  const markedItems = checkAnswers(dropItems, dragItems);
  let totalItems = dragItems.length;
  let totalCorrect = 0;
  for (let i = 0; i < markedItems.length; i++) {
    const dropItem = markedItems[i];
    totalCorrect += dropItem.zones.filter(z => z.isCorrect).length;
  }
  return `You got ${totalCorrect} out of ${totalItems} correct${
    totalCorrect === totalItems ? `! Well done! 🎉` : ''
  }`;
}

export function returnItemToOriginalPosition({
  element,
  droppedDragItemId,
  scale,
  dropItem,
  dropItems,
  dragItems,
  setDragItems,
  setDropItems,
}: {
  element: HTMLElement;
  droppedDragItemId: string;
  scale: number;
  dropItem: DropItem;
  dropItems: DropItem[];
  dragItems: DragItem[];
  setDropItems: (dropItems: DropItem[]) => void;
  setDragItems: (dragItems: DragItem[]) => void;
}) {
  const rect = element.getBoundingClientRect();

  // find slot in menu position and get coords
  const el = document.getElementById(droppedDragItemId || '');
  const originalRect = el?.getBoundingClientRect();

  if (originalRect && el) {
    // translate back to slot
    translateElement({
      element: element as HTMLElement,
      currentOffset: { x: rect.x, y: rect.y },
      initialOffset: {
        x: originalRect.x,
        y: originalRect.y,
      },
      scale,
      onComplete: () => {
        // update state to swap elements
        const zone = dropItem.zones.find(z => z.isCorrect === false);
        if (zone) {
          const dragItem = dragItems.find(d => d.id === zone.dragItemId);
          if (dragItem) {
            dragItem.isDropped = false;
          }
          zone.dragItemId = null;
          zone.isCorrect = undefined;
          setDragItems([...dragItems]);
          setDropItems([...dropItems]);
        }
      },
    });
  }
}

export function getVariant(properties: {
  variant: InquisitiveActivitiesResponseVariant | null;
}) {
  return properties.variant || ACTIVITIES_RESPONSE_VARIANT_IMAGE;
}

export function isTextVariant(
  variant: InquisitiveActivitiesResponseVariant | null
) {
  return variant === ACTIVITIES_RESPONSE_VARIANT_TEXT;
}

export function isTextImageVariant(
  variant: InquisitiveActivitiesResponseVariant | null
) {
  return variant === ACTIVITIES_RESPONSE_VARIANT_TEXT_IMAGE;
}
